import CommonModal from 'components/modals/CommonModal';
import { CommonModalRef } from 'components/modals/CommonModal/CommonModal.props';
import { FC, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Login from 'routes/auth/Login';
import { AuthModalViewProps } from './AuthModal.props';

const AuthModalView: FC<AuthModalViewProps> = ({
  isOpen,
  onClose,
  redirectUrl,
}) => {
  const modalRef = useRef<CommonModalRef>(null);
  const [currentPageUrl, setCurrentPageUrl] = useState('');
  const [initialLocation, setInitialLocation] = useState('');
  const location = useLocation();

  useEffect(() => {
    if (isOpen) {
      // Capture the current page URL when modal opens
      const currentUrl = window.location.pathname + window.location.search;
      setCurrentPageUrl(currentUrl);
      setInitialLocation(currentUrl);
      modalRef.current?.onOpen();
    } else {
      modalRef.current?.onClose?.();
    }
  }, [isOpen]);

  // Close modal when navigation occurs (e.g., user clicks "Sign up")
  useEffect(() => {
    if (isOpen && initialLocation) {
      const currentUrl = location.pathname + location.search;
      if (currentUrl !== initialLocation) {
        // Navigation occurred, close the modal
        handleClose();
      }
    }
  }, [location, isOpen, initialLocation]);

  // No guest-specific listeners needed; guest option removed

  const handleClose = () => {
    onClose?.();
  };

  return (
    <CommonModal
      ref={modalRef}
      className="w-[28rem] max-h-[90vh] overflow-y-auto"
      closeOnBackdropClick={true}
      onSuccessFullyClosed={handleClose}>
      <Login redirectUrl="MODAL_CONTEXT" hideCoverImage />
    </CommonModal>
  );
};

export default AuthModalView;
